import Vue from 'vue'
import Router from 'vue-router'
import Welcome from '../views/Welcome.vue'
import DistributorForm from '../views/DistributorForm.vue'
import Application from '../views/Application.vue'
import goTo from 'vuetify/es5/services/goto'

import store from '../store/store.js'
import i18n from '../plugins/i18n'

// middlewares
import auth from '../middleware/auth';
//import auth1 from '../middleware/auth1';

/*
import Register from './views/Register.vue'
import Login from './views/Login.vue'
import Logout from './views/Logout.vue'
import Lost from './views/Lost.vue'
import Confirm from './views/Confirm.vue'
import Recovery from './views/Recovery.vue'

import MedicalLog from './views/MedicalLog.vue'
import MyClients from './views/MyClients.vue'
import Documents from './views/Documents.vue'
import UploadDocuments from './views/UploadDocuments.vue'

import ReportExperience from './views/ReportExperience.vue'
import GenerateQR from './views/GenerateQR.vue'
*/

Vue.use(Router)

const router = new Router({
    mode: 'history',
    scrollBehavior: (to, from, savedPosition) => {
        let scrollTo = 0

        if (to.hash) {
            scrollTo = to.hash
        } else if (savedPosition) {
            scrollTo = savedPosition.y
        }

        return goTo(scrollTo)
    },
    routes: [{
        path: '/',
        name: 'welcome',
        component: Welcome,
        meta: {
            middleware: auth
        }
    },

    {
        path: '/app/:section?',
        name: 'app',
        component: Application,
        meta: {
            middleware: auth,
            authRequired: true
        }
    },
    {
        path: '/register',
        name: 'distributorForm',
        component: DistributorForm,
        meta: {
            middleware: auth
        }
    },
        /*
              
               {
                   path: '/medicallog',
                   name: 'MedicalLog',
                   component: MedicalLog,
                   meta: {
                       requiresAuth: true
                   }
               },
               {
                   path: '/generateqr',
                   name: 'GenerateQR',
                   component: GenerateQR,
                   meta: {
                       requiresAuth: true
                   }
               },
               {
                   path: '/myclients',
                   name: 'MyClients',
                   component: MyClients,
                   meta: {
                       requiresAuth: true
                   }
               },
               {
                   path: '/documentsupload/:creator/:client/:type?',
                   name: 'DocumentsUpload',
                   component: UploadDocuments,
                   meta: {
                       requiresAuth: true
                   }
               },
               {
                   path: '/documents',
                   name: 'Documents',
                   component: Documents,
                   meta: {
                       requiresAuth: true
                   }
               },
               {
                   path: '/register',
                   name: 'Register',
                   component: Register,
                   meta: {
                       requiresVisitor: true
                   }
               },
               {
                   path: '/login',
                   name: 'Login',
                   component: Login,
                   meta: {
                       requiresVisitor: true
                   }
               },
               {
                   path: '/recovery/:token',
                   name: 'Recovery',
                   component: Recovery,
                   props: true,
               },
               {
                   path: '/confirmation/:token',
                   name: 'confirmation',
                   component: Confirm,
                   props: true,
               },
               {
                   path: '/logout',
                   name: 'Logout',
                   component: Logout
               },
               {
                   path: '/lost',
                   name: 'Lost',
                   component: Lost
               },
               {
                   path: '/report',
                   name: 'ReportExperience',
                   component: ReportExperience,
                   props: route => ({ query: route.query.hash }),
                   meta: {
                       requiresAuth: true
                   }
               },
               */
    ]
})


// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
    const subsequentMiddleware = middleware[index];
    // If no subsequent Middleware exists,
    // the default `next()` callback is returned.
    if (!subsequentMiddleware) return context.next;

    return (...parameters) => {
        // Run the default Vue Router `next()` callback first.
        context.next(...parameters);
        // Then run the subsequent Middleware with a new
        // `nextMiddleware()` callback.
        const nextMiddleware = nextFactory(context, middleware, index + 1);
        subsequentMiddleware({ ...context, next: nextMiddleware });
    };
}

router.beforeEach((to, from, next) => {

    if (to.query.lang) {
        i18n.locale = to.query.lang
    }

    if (to.meta.middleware) {
        const middleware = Array.isArray(to.meta.middleware)
            ? to.meta.middleware
            : [to.meta.middleware];

        const context = {
            from,
            next,
            router,
            to,
            store
        };
        const nextMiddleware = nextFactory(context, middleware, 1);

        return middleware[0]({ ...context, next: nextMiddleware });
    }

    return next();
});

export default router
